var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from "react";
import { createPortal } from "react-dom";
import NotificationsContext from "./NotificationsContext";
import Notification from "./Notification";
import { NotificationsStackStyled } from "./NotificationsStackStyled";
var NotificationsStack = function (props) {
    var notifications = useContext(NotificationsContext).notifications;
    return createPortal(React.createElement(NotificationsStackStyled, null, notifications.map(function (n, i) {
        return (React.createElement("div", { className: "notification-container", key: "notification-" + i },
            React.createElement(Notification, __assign({}, n))));
    })), document.querySelector("#notifications-stack"));
};
export default NotificationsStack;
//# sourceMappingURL=NotificationsStack.js.map